import React from 'react';

import Styles from './Table.module.scss';
import PropTypes from 'prop-types';

export default function Table({ data }) {
  const { Table, Row } = Styles;
  return (
    <div className={Table}>
      <header>
        <div>Usuário</div>
        <div>Região</div>
        <div>Cultura</div>
      </header>
      <main>
        {data.map(d => (
          <div className={Row}>
            <div>{d.user}</div>
            <div>{d.regions}</div>
            <div>{d.cultures}</div>
          </div>
        ))}
        <footer />
      </main>
    </div>
  );
}

Table.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      user: PropTypes.string, // Who is the user
      regions: PropTypes.number, // How many regions did him cover?
      cultures: PropTypes.number, // How many cultures did him reviewed?
    }),
  ).isRequired,
};
